import React from 'react';
import styled from 'styled-components';
import WveInputSelect from 'SharedComponents/WveInputs/WveInputSelect/WveInputSelect';
import WveStyleElementLabel from 'Components/WveSettingsPanel/WveStyleElement/WveStyleElementLabel/WveStyleElementLabel';

const Row = styled.div`
  display: flex;
  align-items: center;
  border: none;
  padding: 15px 0 0 10px;
`;

const WveSelect = styled(WveInputSelect)`
  margin-right: auto;
  width: 70%;
  max-width: none;
`;

const VariantSelector = () => (<Row>
  <WveStyleElementLabel label="variant" />
  <WveSelect
    options={['No variants']}
    onChange={() => {}}
  />
</Row>);

export default VariantSelector;



// WEBPACK FOOTER //
// ./app/javascript/packs/App/Preview/components/SideBar/VariantSelector/VariantSelector.jsx